import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { BaseCrud } from 'core-components/types'

import { getKeyField } from '../../helpers'
import styles from '../../Table.module.scss'
import { RowState, TTableProps } from '../types'

import { getValue } from './utils'

export const getHierarchy = <P, R>(
  props: TTableProps<P, R>,
  rows: { [propname: string]: RowState },
  setRows: (rows: { [propname: string]: RowState }) => void,
  openNode: (key: string) => Promise<P[]>,
  currentSource: BaseCrud<P, R>
) => {
  const updateRows = (key: string, current: RowState) => {
    setRows({
      ...rows,
      [key]: {
        ...current,
      },
    })
  }

  const source = props.source || currentSource
  const keyField = getKeyField({ source, keyField: props.keyField })

  return {
    hierarchyContent:
      props.hierarchyContent ||
      ((item: P, rowState: RowState, hierarchyClick: (item: P) => Promise<void>) => {
        const hasChildren = getValue(item, 'hasChildren')
        return (
          <>
            {hasChildren ? (
              rowState.loading ? (
                <div className={styles.expandPlaceholder}>
                  <Loader dimension={{ height: 20, width: 20 }} />
                </div>
              ) : (
                <Button
                  className={rowState.expanded ? styles.hierarchyIconExpanded : ''}
                  iconButton={
                    rowState.expanded ? 'kbase kbase-caret-down' : 'kbase kbase-caret-right'
                  }
                  variant={'text'}
                  onClick={(e) => {
                    e.stopPropagation()
                    hierarchyClick(item)
                  }}
                />
              )
            ) : (
              <div className={styles.expandPlaceholder} />
            )}
          </>
        )
      }),
    hierarchyClick: async (item: P, hierarchyField: string = 'Relation') => {
      const key = getValue(item, keyField)
      const current = rows[key] || {}
      if (!current.expanded) {
        current.loading = true
        updateRows(key, current)

        const childRows = await openNode(key)
        if (childRows instanceof Array) {
          current.hasChildren =
            item[hierarchyField] !== undefined
              ? item[hierarchyField]
              : !!childRows.filter((childItem) => childItem[hierarchyField] === key).length
        }
      }
      current.loading = false
      current.expanded = !current.expanded
      if (!current.expanded) {
        source.closeExpandedRoot(key as any)
      }

      updateRows(key, current)
      return current
    },
    isExpanded: (item: P) => {
      const key = getValue(item, keyField)
      const current = rows[key] || {}
      return current.expanded
    },
  }
}
